<template>
  <div class="us">
    <div class="us__bg"></div>
    <div class="us__content">
      <div class="us__title-wrapper">
        <h2 class="us__title">US</h2>
      </div>
      <div class="us__header-wrapper">
        <h5 class="us__header">
          We are in business because of technology, but we are successful thanks
          to our people. We are a team of doers united by a simple idea:
        </h5>
      </div>
      <div class="us__slogan us__slogan--desktop">
        <h2 class="us__text us__text--left">
          CONNECT <br />
          TO BUILD
        </h2>
        <h1 class="us__text us__text--mid">GREAT</h1>
        <h2 class="us__text us__text--right">
          PEOPLE <br />
          THINGS
        </h2>
      </div>
      <div class="us__slogan us__slogan--mobile">
        <h2 class="us__text us__text--top">
          CONNECT <br />
          <span>GREAT</span> <br />
          PEOPLE
        </h2>
        <h2 class="us__text us__text--bottom">
          TO BUILD <br />
          <span>GREAT</span> <br />
          THINGS
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.us {
  &__bg {
    clip-path: polygon(0 30%, 50% 0%, 100% 30%, 100% 100%, 0 50%);
    background-color: #666;
    position: relative;
    background-image: url(../../assets/img/bg1.jpg);
    background-size: cover;
    text-align: center;
    height: 140vh;
    position: absolute;
    width: 100%;
    z-index: 0;
    &:after {
      content: '';
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
    @include mq-max(991px) {
      clip-path: polygon(0 20%, 50% 0%, 100% 20%, 100% 100%, 0 80%);
    }
    @include mq-max(450px) {
      clip-path: polygon(0 10%, 50% 0%, 100% 10%, 100% 100%, 0 80%);
      height: 200vh;
    }
  }
  &__content {
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    font-family: Roboto;
    padding-top: 5rem;
    position: relative;
  }
  &__title {
    color: #f05a28;
    font-size: 96px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 7.2rem;
    margin-top: 5rem;
    @include mq-max(991px) {
      margin-top: 12rem;
    }
    @include mq-max(450px) {
      margin-top: 3rem;
    }
  }
  &__header {
    margin: 0 auto;
    margin-top: 5rem;
    color: #ffffff;
    font-size: 2.4rem;
    letter-spacing: -0.2rem;
    line-height: 2.8rem;
    text-align: center;
    max-width: 50rem;
    @include mq-max(991px) {
      font-size: 2.2rem;
      max-width: 35rem;
    }
    @include mq-max(450px) {
      max-width: 80%;
    }
  }
  &__slogan {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 5rem;
    &--desktop {
      @include mq-max(991px) {
        display: none;
      }
    }
    &--mobile {
      display: none;
      flex-direction: column;
      .us__text {
        font-size: 3.2rem;
        font-weight: bold;
        letter-spacing: -0.2rem;
        line-height: 3.2rem;
        span {
          font-size: 9rem;
          font-weight: bold;
          letter-spacing: -0.5rem;
          line-height: 8rem;
        }
        &:first-child {
          margin-bottom: 2.5rem;
        }
      }
      @include mq-max(991px) {
        display: flex;
      }
    }
  }
  &__text {
    color: $white;
    font-weight: bold;
    &--left,
    &--right {
      font-size: 6.4rem;
      font-weight: bold;
      letter-spacing: -0.4rem;
      line-height: 5.6rem;
      text-align: center;
    }
    &--mid {
      color: #ffffff;
      font-size: 14.4rem;
      font-weight: bold;
      letter-spacing: -1rem;
      line-height: 12.8rem;
      text-align: center;
      display: inline-block;
      padding: 0 2rem;
    }
  }
}
</style>
